// FETCH ALL PROGRAM_CONSTRAINT
export const FETCH_PROGRAM_CONSTRAINT_REQUEST = 'FETCH_PROGRAM_CONSTRAINT_REQUEST';
export const FETCH_PROGRAM_CONSTRAINT_SUCCESS = 'FETCH_PROGRAM_CONSTRAINT_SUCCESS';
export const FETCH_PROGRAM_CONSTRAINT_FAILURE = 'FETCH_PROGRAM_CONSTRAINT_FAILURE';

// FETCH ALL CURRENCY
export const FETCH_CURRENCY_REQUEST = 'FETCH_CURRENCY_REQUEST';
export const FETCH_CURRENCY_SUCCESS = 'FETCH_CURRENCY_SUCCESS';
export const FETCH_CURRENCY_FAILURE = 'FETCH_CURRENCY_FAILURE';

// CREATE PROGRAM_CONSTRAINT
export const CREATE_PROGRAM_CONSTRAINT_REQUEST = 'CREATE_PROGRAM_CONSTRAINT_REQUEST';
export const CREATE_PROGRAM_CONSTRAINT_SUCCESS = 'CREATE_PROGRAM_CONSTRAINT_SUCCESS';
export const CREATE_PROGRAM_CONSTRAINT_FAILURE = 'CREATE_PROGRAM_CONSTRAINT_FAILURE';

// UPDATE PROGRAM_CONSTRAINT
export const UPDATE_PROGRAM_CONSTRAINT_REQUEST = 'UPDATE_PROGRAM_CONSTRAINT_REQUEST';
export const UPDATE_PROGRAM_CONSTRAINT_SUCCESS = 'UPDATE_PROGRAM_CONSTRAINT_SUCCESS';
export const UPDATE_PROGRAM_CONSTRAINT_FAILURE = 'UPDATE_PROGRAM_CONSTRAINT_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_PROGRAM_CONSTRAINT_REQUEST = 'FETCH_SINGLE_PROGRAM_CONSTRAINT_REQUEST';
export const FETCH_SINGLE_PROGRAM_CONSTRAINT_SUCCESS = 'FETCH_SINGLE_PROGRAM_CONSTRAINT_SUCCESS';
export const FETCH_SINGLE_PROGRAM_CONSTRAINT_FAILURE = 'FETCH_SINGLE_PROGRAM_CONSTRAINT_FAILURE';

// DELETE PROGRAM_CONSTRAINT
export const DELETE_PROGRAM_CONSTRAINT_REQUEST = 'DELETE_PROGRAM_CONSTRAINT_REQUEST';
export const DELETE_PROGRAM_CONSTRAINT_SUCCESS = 'DELETE_PROGRAM_CONSTRAINT_SUCCESS';
export const DELETE_PROGRAM_CONSTRAINT_FAILURE = 'DELETE_PROGRAM_CONSTRAINT_FAILURE';

export const RESET_PROGRAM_CONSTRAINT_INFO = 'RESET_PROGRAM_CONSTRAINT_INFO';

export const CREATE_PROGRAM_CONSTRAINT_FORM = 'CREATE_PROGRAM_CONSTRAINT_FORM';

export const UPDATE_PROGRAM_CONSTRAINT_FORM = 'UPDATE_PROGRAM_CONSTRAINT_FORM';
